import { i as B, e as M, u as y, x as u, E, n as v, r as h } from "./abstract-base-CdeHT0x1.js";
import { e as L } from "./class-map-Ckx5HLrM.js";
import { B as P } from "./table-cell-eFwJxJGY.js";
import { B as G } from "./events-CMiHMbSn.js";
import { p as V } from "./lifecycle-decorators-VlFt_asj.js";
import { a as Z } from "./query-assigned-DiX8lRAH.js";
import { B as q } from "./icon-button-PZmQvhbY.js";
var p = /* @__PURE__ */ ((n) => (n.ASCENDING = "ascending", n.DESCENDING = "descending", n))(p || {}), W = /* @__PURE__ */ ((n) => (n.NORMAL = "normal", n.GROUP = "group", n.JUMBO = "jumbo", n))(W || {});
function F(n, e) {
  if (n) {
    if (e && e.includes(n.localName))
      return n.id;
    if (n.parentElement)
      return n.parentElement.id;
  }
  return "";
}
const U = "headers";
function H(n, e, t, a, r, o, i) {
  var N, C, D, I, $;
  const d = e ? ($ = (I = (D = n == null ? void 0 : n.parentElement) == null ? void 0 : D.parentElement) == null ? void 0 : I.nextElementSibling) == null ? void 0 : $.children : (C = (N = n == null ? void 0 : n.parentElement) == null ? void 0 : N.nextElementSibling) == null ? void 0 : C.children, b = F(n, a);
  let f;
  if (d && b) {
    const w = Array.from(d);
    if (w && w.length && (f = w.filter((S) => {
      const z = S.getAttribute(U);
      let j;
      return S && z && z === b && (t && r && r(S), j = S), j;
    })), f)
      return i && i(f, n), o && o(f, n), f;
  }
}
const _ = B`:root[beacon-tag-name=beacon-table-header],:root [beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-header]{--table-header-space-zero-value: 0;--table-header-sort-icon-size: var(--beacon-reference-space-5);--table-header-dropdown-space-padding-block-start-jumbo: 0;--table-header-dropdown-space-padding-block-start-normal: 0;--table-header-nth-cell-space-padding-block-start-jumbo: 5px;--table-header-nth-cell-space-padding-block-start-normal: var(--beacon-reference-space-1);--table-header-sort-wrapper-space-padding-block-start-jumbo: 0;--table-header-sort-wrapper-space-padding-block-start-normal: var(--beacon-reference-space-0);--beacon-table-header-action-zone-space-padding-block-start-jumbo: 0;--table-header-action-zone-space-padding-block-start-normal: var(--beacon-reference-space-0)}@media (width >= 640px){:root[beacon-tag-name=beacon-table-header],:root [beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-header]{--table-header-dropdown-space-padding-block-start-jumbo: var(--beacon-reference-space-0);--table-header-dropdown-space-padding-block-start-normal: var(--beacon-reference-space-0);--table-header-nth-cell-space-padding-block-start-jumbo: var(--beacon-reference-space-2);--table-header-nth-cell-space-padding-block-start-normal: var(--beacon-reference-space-2);--table-header-sort-wrapper-space-padding-block-start-jumbo: var(--beacon-reference-space-0);--table-header-sort-wrapper-space-padding-block-start-normal: var(--beacon-reference-space-1);--beacon-table-header-action-zone-space-padding-block-start-jumbo: var(--beacon-reference-space-0);--table-header-action-zone-space-padding-block-start-normal: var(--beacon-reference-space-1)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-table-header],:root [beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-header]{--table-header-dropdown-space-padding-block-start-jumbo: var(--beacon-reference-space-1);--table-header-dropdown-space-padding-block-start-normal: 0;--table-header-sort-wrapper-space-padding-block-start-normal: var(--beacon-reference-space-2);--table-header-action-zone-space-padding-block-start-normal: var(--beacon-reference-space-2)}}`, J = B`:host{--cell-wrapper-padding-inline-end: 0;--override-icon-button-wrapper-inline-size: var(--table-header-sort-icon-size);--override-icon-button-wrapper-block-size: var(--table-header-sort-icon-size);font:inherit;inline-size:inherit;overflow:inherit;text-align:inherit;text-transform:inherit;word-break:initial}.hide{display:none}.has-cell-padding{padding-block:var(--table-header-space-zero-value);padding-inline:var(--table-header-space-zero-value)}.table-header-wrapper{display:flex;gap:var(--beacon-reference-space-5);inline-size:var(--table-override-header-wrapper-inline-size, inherit);padding-inline-end:var(--cell-wrapper-padding-inline-end)}.table-header-wrapper .text-cell{display:flex;gap:var(--beacon-reference-space-3);inline-size:100%}.table-header-wrapper .text-cell__text{--text-cell-padding-block-start: var(--table-header-nth-cell-space-padding-block-start-normal);color:var(--beacon-system-color-text-standard);display:grid;gap:var(--beacon-reference-space-1);inline-size:inherit;padding-block-start:var(--table-header-space-zero-value);padding-inline-start:var(--table-header-space-zero-value)}.table-header-wrapper .text-cell__text .title{margin:0;font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}.table-header-wrapper .text-cell__text .subtitle{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);margin:0}.table-header-wrapper .sort-icon{--sort-icon-padding-block-start: var(--table-header-sort-wrapper-space-padding-block-start-normal);display:var(--table-override-header-sort-icon-display, initial);padding-block-start:var(--table-header-space-zero-value)}.table-header-wrapper ::slotted([slot=action-zone]){--action-zone-padding-block-start: var(--table-header-action-zone-space-padding-block-start-normal);padding-block-start:0}.table-header-wrapper select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;background-origin:content-box;background-position:right center;background-repeat:no-repeat;border:0;cursor:inherit;inline-size:100%;overflow:hidden;padding:0;text-overflow:ellipsis;white-space:break-spaces;word-break:break-word}.table-header-wrapper select:hover{text-decoration:underline}.table-header-wrapper .selected-value{position:absolute;visibility:hidden;white-space:nowrap}.table-header-wrapper.jumbo select,.table-header-wrapper.jumbo .selected-value,.table-header-wrapper.jumbo .title,.table-header-wrapper.jumbo .table-dropdown{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}.table-header-wrapper.jumbo .subtitle{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.table-header-wrapper.jumbo .text-cell__text{--text-cell-padding-block-start: var(--table-header-nth-cell-space-padding-block-start-jumbo)}.table-header-wrapper.jumbo .sort-icon{--sort-icon-padding-block-start: var(--table-header-sort-wrapper-space-padding-block-start-jumbo)}.table-header-wrapper.jumbo ::slotted([slot=action-zone]){--action-zone-padding-block-start: var(--table-header-action-zone-space-padding-block-start-jumbo)}.table-header-wrapper .table-dropdown{--dropdown-padding-block-start: var(--table-header-dropdown-space-padding-block-start-normal);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200);background-color:transparent;background-image:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 6L8 10L4 6" stroke="%230063AD" stroke-linecap="round" stroke-linejoin="round"/></svg>');color:var(--beacon-system-color-text-link);cursor:pointer;display:var(--table-override-header-dropdown-display, flex);padding-block-start:0}.table-header-wrapper.jumbo .table-dropdown{--dropdown-padding-block-start: var(--table-header-dropdown-space-padding-block-start-jumbo)}`;
var Q = Object.defineProperty, Y = Object.getOwnPropertyDescriptor, c = (n, e, t, a) => {
  for (var r = a > 1 ? void 0 : a ? Y(e, t) : e, o = n.length - 1, i; o >= 0; o--)
    (i = n[o]) && (r = (a ? i(e, t, r) : i(r)) || r);
  return a && r && Q(e, t, r), r;
};
const k = "beacon-table-header", T = "aria-sort", K = ".beacon-table", X = ".cell", ee = "has-dropdown", te = "headers", O = "display: none", g = "beacon-icon-button", m = "number-of-headers", x = "selected", ae = ".selected-value", R = "sorted", re = "sort-direction", ne = "sort-inactive", A = "style";
var s;
const l = (s = class extends P {
  constructor() {
    super(...arguments), this.subtitle = "", this.variant = W.NORMAL, this.dropdown = !1, this.sortable = !1, this.hasActionZone = !1, this.hasSubtitle = !1, this.sortInactive = !1, this.selectedValue = "select", this.selectedWidth = 0, this.nestedHeaders = [], this.beaconTagName = k, this.compare = (e, t) => this.sortDirection === p.ASCENDING ? e.value === t.value ? 0 : typeof e.value == "number" && typeof t.value == "number" ? e.value - t.value : e.value < t.value ? -1 : 1 : this.sortDirection === p.DESCENDING ? e.value === t.value ? 0 : typeof e.value == "number" && typeof t.value == "number" ? t.value - e.value : e.value > t.value ? -1 : 1 : 0, this.processNestedHeaders = (e) => {
      var t, a;
      if (e) {
        const r = (a = (t = this.parentElement) == null ? void 0 : t.parentElement) == null ? void 0 : a.children, o = r && Array.from(r);
        let i = 0;
        o && (i = this.findStartingIndex(o, e));
        for (const [d, b] of e.entries())
          b.id && this.nestedHeaders.push({
            value: b.id,
            selected: b.hasAttribute(x),
            colId: d + i
          });
        i && this.prepStyleObj(this.nestedHeaders);
      }
    }, this.prepStyleObj = (e) => {
      const t = document.querySelector(K), a = t == null ? void 0 : t.querySelector(
        `${A}[${m}='${this.currentIndex}']`
      );
      a && (t == null || t.removeChild(a));
      const r = `{${O}}`;
      let o = "";
      for (const d of e)
        d.selected || (o = `${o + s.prepareStyleString(d.colId)},`);
      o = s.removeLastCharacter(o);
      const i = o + r;
      t && (t.classList.contains("beacon-table--has-selected-columns") || t.classList.add("beacon-table--has-selected-columns"), s.createStyleTag(t, i, this.currentIndex));
    };
  }
  static get styles() {
    return [super.styles, J];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, _];
  }
  postrenderTableHeaderSetup() {
    var e;
    if (this.dropdown) {
      H(
        this,
        !0,
        !0,
        void 0,
        s.setDropdownAttributes,
        s.setSelectedAttributes,
        s.siblingCollectionCallback
      );
      const t = (e = this.nestedHeaders.find(
        (a) => a.selected
      )) == null ? void 0 : e.value;
      this.selectedValue = t || this.selectedValue, this.adjustSelectWidth(), this.setColSpanForDropdowns();
      return;
    }
    H(
      this,
      !0,
      !1,
      void 0,
      void 0,
      void 0,
      s.siblingCollectionCallback
    );
  }
  /** Sets a data attribute on the parent element equal to the columns it would span if it wasn't using the dropdown feature. */
  setColSpanForDropdowns() {
    var e;
    this.parentElement && ((e = this.subHeaderNodes) == null ? void 0 : e.length) > 0 && (this.parentElement.dataset.colSpan = this.subHeaderNodes.length.toString());
  }
  /**
   * Process while on column sort happens.
   */
  onSort() {
    var e;
    if (this.sortable) {
      const t = ((e = this.parentElement) == null ? void 0 : e.id) || "", a = s.getParentElementHeaders(this);
      this.sortDirection === p.ASCENDING ? this.sortDirection = p.DESCENDING : this.sortDirection = p.ASCENDING, M(this, G.SORT, { detail: { id: t, headers: a } }), this.setSortedAttr();
    }
  }
  /**
   * Sets related ARIA_SORT attribute to the parentElement th. This being used when sort happens.
   */
  setSortedAttr() {
    var e, t;
    (e = this.parentElement) == null || e.setAttribute(
      T,
      this.sortDirection
    ), (t = this.parentElement) == null || t.classList.add(R), this.sortInactive = !1;
  }
  /**
   * When Sorting happens on another columns this removes any sort attributes applied to parentElement th.
   * @param ele HTMLElement| Element
   */
  resetSortedAttr() {
    var e, t;
    this && (this.setAttribute(ne, "true"), this.removeAttribute(re), (e = this.parentElement) == null || e.removeAttribute(T), (t = this.parentElement) == null || t.classList.remove(R));
  }
  /**
   * Based on sortInactive returns token value.
   * @returns token value.
   */
  applySvgToken() {
    return this.sortInactive ? "var(--beacon-reference-palette-grayscale-medium-gray-2)" : "var(--beacon-system-color-icon-link)";
  }
  /**
   *
   * @returns TemplateResult
   */
  handleSortIcon() {
    let e;
    return this.sortable && (this.sortDirection === p.ASCENDING ? e = y`<${this.getScopedTag(g)}
          @beacon-event-click="${this.onSort}"
          id="${p.ASCENDING}"
          variant="tertiary"
          class="sort-icon"
        >
          Sorted Ascending
          <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3L12 8H8.5L8.5 13H7.5L7.5 8H4L8 3Z" style="fill: ${this.applySvgToken()}" />
          </svg>
        </${this.getScopedTag(g)}>` : this.sortDirection === p.DESCENDING ? e = y`<${this.getScopedTag(g)}
          @beacon-event-click="${this.onSort}"
          id="${p.DESCENDING}"
          variant="tertiary"
          class="sort-icon"
        >
          Sorted Descending
          <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.5 8L8.5 3H7.5L7.5 8H4L8 13L12 8H8.5Z"
              style="fill: ${this.applySvgToken()}"
            />
          </svg>
        </${this.getScopedTag(g)}> ` : e = y`<${this.getScopedTag(g)}
          @beacon-event-click="${this.onSort}"
          id="sort"
          variant="tertiary"
          class="sort-icon"
        >
          Sort
          <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2L11 6H5L8 2ZM8 14L5 10H11L8 14Z" style="fill: ${this.applySvgToken()}" />
          </svg>
        </${this.getScopedTag(g)}>`), e || u``;
  }
  /**
   * Triggers when selection change happens to dropdown.
   * @param event
   */
  async handleSelectChange(e) {
    const { target: t } = e;
    t && (this.selectedValue = t.value), this.resetSortedAttr(), await this.updateComplete.then(() => (this.updateNestedHeaders(), this.prepStyleObj(this.nestedHeaders), this.adjustSelectWidth()));
  }
  /**
   * It processes nestedHeaders based on provided array.
   */
  updateNestedHeaders() {
    this.nestedHeaders && this.nestedHeaders.forEach((e) => {
      e.selected ? e.selected = !1 : e.value === this.selectedValue && (e.selected = !0);
    });
  }
  /**
   * While Dropdown is true, this will update correct spacing for the arrow icon and text.
   */
  async adjustSelectWidth() {
    var a, r, o;
    await this.updateComplete;
    const e = this.shadowRoot && ((a = this.shadowRoot) == null ? void 0 : a.querySelector(ae)), t = this.shadowRoot && ((r = this.shadowRoot) == null ? void 0 : r.querySelector(X));
    if (e && t) {
      const i = (o = window.getComputedStyle(t)) == null ? void 0 : o.paddingLeft, d = i && parseInt(i, 10) || 0, b = e.offsetWidth;
      b < t.offsetWidth - d ? this.selectedWidth = b + 4 : this.selectedWidth = 0;
    }
  }
  /**
   * Pass collection of below elements to return from what could be the starting index for particular table-header.
   * @param parentElsArr Element[] - Collection of parentElement[]
   * @param currentEl Element[] - Collection of currentElement[]
   * @returns number
   */
  findStartingIndex(e, t) {
    this.setAttribute(m, t.length.toString()), this.currentIndex = e == null ? void 0 : e.findIndex(
      (r) => r === this.parentElement
    );
    let a = 0;
    for (let r = 0; r < this.currentIndex; r += 1) {
      const o = e[r];
      if (o) {
        const i = o.firstElementChild;
        if (i && i.hasAttribute(m)) {
          const d = i.getAttribute(m);
          d && (a = parseInt(d, 10) + a);
        } else
          a = a + 1;
      }
    }
    return a;
  }
  /**
   * Provided string to be checked if it has any extra comma available at the end and it will remove it.
   * @param str string
   * @returns string
   */
  static removeLastCharacter(e) {
    let t = "";
    return e && e.lastIndexOf(",") === e.length - 1 && (t = e.substring(0, e.length - 1)), t;
  }
  /**
   * Based on index will prepare string to hide column.
   * @param index number
   * @returns string
   */
  static prepareStyleString(e) {
    return `.beacon-table--has-selected-columns td:nth-of-type(${e})`;
  }
  /**
   * Sets state variable dependent on slotted action-zone elements
   */
  actionZoneSlotChange() {
    var e;
    this.hasActionZone = !!((e = this.slottedActionZone) != null && e.length);
  }
  /**
   * Action zone render method that conditionally hides padding based on `hasActionZone` state variable
   */
  renderActionZone() {
    const e = {
      "has-cell-padding": !0,
      "action-cell": !0,
      hide: !this.hasActionZone
    };
    return u`
      <div class=${L(e)}>
        <slot
          name="action-zone"
          @slotchange=${this.actionZoneSlotChange}></slot>
      </div>
    `;
  }
  /**
   * Sets state variable dependent on slotted subtitle element or property content
   *
   */
  subtitleSlotChange() {
    var e;
    this.hasSubtitle = !!((e = this.slottedSubtitle) != null && e.length) || !!this.subtitle;
  }
  /**
   * Renders subtitle html with conditional rendering of `.hide` class
   * Need to hide subtitle to prevent css from adding `gap` space within elements of `text-cell__text`
   */
  renderSubtitle() {
    const e = {
      subtitle: !0,
      hide: !this.hasSubtitle
    };
    return u`
      <p class=${L(e)}>
        <slot @slotchange=${this.subtitleSlotChange} name="subtitle"
          >${this.subtitle}</slot
        >
      </p>
    `;
  }
  render() {
    return u`<div class="table-header-wrapper ${this.variant}">
      <div class="has-cell-padding text-cell" part="text-cell">
        <div class="text-cell__text">
          <p class="title" id="header-title">
            <slot></slot>
          </p>
          ${this.renderSubtitle()}
          ${this.dropdown ? u`<select
                  id="select"
                  @change="${this.handleSelectChange}"
                  style="background-position: ${this.selectedWidth ? `${this.selectedWidth}px` : "left 100% top 50%"};
                width: ${this.selectedWidth ? "100%" : "calc(100% + 4px)"}"
                  name="dropdown"
                  class="table-dropdown"
                  value=${this.selectedValue}
                  aria-label="${this.selectedValue}">
                  ${this.nestedHeaders ? this.nestedHeaders.map(
      (e) => u`<option ?selected=${e.selected}>
                            ${e.value}
                          </option>`
    ) : E}
                </select>
                <span class="selected-value" aria-hidden="true"
                  >${this.selectedValue}</span
                >` : E}
        </div>
        ${this.sortable ? this.handleSortIcon() : E}
      </div>
      ${this.renderActionZone()}
    </div> `;
  }
}, s.tagName = k, s.nestedComponents = [q], s.getParentElementHeaders = (e) => {
  let t = "";
  return e && e.parentElement && (t = e.parentElement.getAttribute(te) || ""), t;
}, s.getSelectedFromElements = (e) => {
  let t;
  return e && e.length && (t = (e == null ? void 0 : e.find((a) => a.hasAttribute(x))) || e[0]), t;
}, s.createStyleTag = (e, t, a) => {
  if (e) {
    const r = document.createElement(A);
    r.innerText = `${t}`, r.setAttribute(m, a.toString()), e == null || e.appendChild(r);
  }
}, s.setDropdownAttributes = (e) => {
  var t;
  e.setAttribute(A, O), (t = e.parentElement) == null || t.setAttribute(ee, "");
}, s.siblingCollectionCallback = (e, t) => {
  const a = [];
  e.map(
    (o) => o.querySelector(t.getScopedTagName(k))
  ).forEach((o) => {
    o && o instanceof s && a.push(o);
  }), t.subHeaderNodes = a;
}, s.setSelectedAttributes = (e, t) => {
  const a = s.getSelectedFromElements(e);
  a == null || a.setAttribute(x, ""), t.processNestedHeaders(e);
}, s);
c([
  v({
    reflect: !0,
    alternateSlot: "subtitle",
    sync: !1
  })
], l.prototype, "subtitle", 2);
c([
  v({ reflect: !0 })
], l.prototype, "variant", 2);
c([
  v({ attribute: "dropdown", type: Boolean, reflect: !0 })
], l.prototype, "dropdown", 2);
c([
  v({ attribute: "sortable", type: Boolean, reflect: !0 })
], l.prototype, "sortable", 2);
c([
  h()
], l.prototype, "hasActionZone", 2);
c([
  h()
], l.prototype, "hasSubtitle", 2);
c([
  v({ attribute: "sort-direction", reflect: !0 })
], l.prototype, "sortDirection", 2);
c([
  v({ attribute: "sort-inactive", type: Boolean, reflect: !0 })
], l.prototype, "sortInactive", 2);
c([
  Z({ flatten: !0, slot: "action-zone" })
], l.prototype, "slottedActionZone", 2);
c([
  Z({ flatten: !0, slot: "subtitle" })
], l.prototype, "slottedSubtitle", 2);
c([
  h()
], l.prototype, "selectedValue", 2);
c([
  h()
], l.prototype, "selectedWidth", 2);
c([
  h()
], l.prototype, "subHeaderNodes", 2);
c([
  h()
], l.prototype, "nestedHeaders", 2);
c([
  h()
], l.prototype, "currentIndex", 2);
c([
  V
], l.prototype, "postrenderTableHeaderSetup", 1);
let be = l;
export {
  be as B,
  p as S,
  H as f
};
